import React from 'react';
import { usePromiseFetchSite } from '.';
import { Booking } from '../../interfaces';
import Statsbox from '../../components/stats-box';

const ActiveBookingsCount = (): JSX.Element => {
  const [fetching, response] = usePromiseFetchSite(
    '/bookings?bookingStatus=Active&status=Not delivered'
  );

  const {
    bookings,
    size,
    total
  }: { bookings: Booking[]; size: number; total: number } = response ?? {
    bookings: [],
    size: 40,
    total: 0
  };

  return (
    <a href="/bookings?bookingStatus=Active&amp;status=Not delivered">
      <Statsbox
        iconColorClass="text-success"
        bgClass="dark"
        fetching={fetching}
        title={total}
        caption="Active bookings"
        faIconName="fas fa-check-circle"
      />
    </a>
  );
};

export default ActiveBookingsCount;
